export default __webpack_public_path__ + "static/media/hugging.d30bd8ee.png";